import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=cbe9d78e&scoped=true"
import script from "./SectionLayout.vue?vue&type=script&lang=js"
export * from "./SectionLayout.vue?vue&type=script&lang=js"
import style0 from "./SectionLayout.vue?vue&type=style&index=0&id=cbe9d78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe9d78e",
  null
  
)

export default component.exports